import { useRef, useState } from "react";
import api, { API, apiError } from "@/lib/api";
import { toast } from "sonner";
import { FileText, X, Loader2, Upload } from "lucide-react";

export const docUrl = (id) => `${API}/files/${id}`;

export const DocumentUpload = ({ documents = [], onChange, label = "Nachweise (Versicherung, Genehmigungen) – PDF oder Bild, max. 5 à 8 MB" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    if (documents.length + files.length > 5) { toast.error("Maximal 5 Dateien"); return; }
    const fd = new FormData();
    files.forEach((f) => fd.append("files", f));
    setBusy(true);
    try {
      const { data } = await api.post("/uploads/documents", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange([...documents, ...data.files.map((f) => f.id)]);
      toast.success(`${data.files.length} Datei(en) hochgeladen`);
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="document-upload">
      <label className="eb-label">{label}</label>
      <div className="flex flex-wrap gap-2 mt-2">
        {documents.map((id, i) => (
          <span key={id} className="flex items-center gap-1.5 rounded-md border border-slate-700 px-2.5 py-1.5 text-xs text-slate-300" data-testid={`document-chip-${id}`}>
            <FileText className="w-3.5 h-3.5 text-[#FF5A1F]" /> <a href={docUrl(id)} target="_blank" rel="noreferrer" className="underline">Nachweis {i + 1}</a>
            <button type="button" onClick={() => onChange(documents.filter((d) => d !== id))} data-testid={`document-remove-${id}`}><X className="w-3 h-3" /></button>
          </span>
        ))}
        {documents.length < 5 && (
          <button type="button" onClick={() => ref.current?.click()} disabled={busy} className="eb-btn-outline !py-1.5 text-xs" data-testid="document-add-btn">
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />} Datei hochladen
          </button>
        )}
      </div>
      <input ref={ref} type="file" accept="image/*,application/pdf" multiple className="hidden" onChange={pick} data-testid="document-file-input" />
    </div>
  );
};
